import Hero from "../../components/Hero";
import WealthManagementImage from "../../../assets/images/Wealth1.jpg";
import WealthManagementImage2 from "../../../assets/images/Wealth2.jpg";
import WealthManagementImage3 from "../../../assets/images/Wealth 3.jpg";
import WealthManagementImage4 from "../../../assets/images/Wealth 4.jpg";
import WealthManagementImage5 from "../../../assets/images/Wealth 5.jpg";

const WealthManagement = () => {
  return (
    <div>
      <Hero
        backgroundImage={WealthManagementImage}
        title="Wealth Management"
        subtitle="OUR SERVICES"
      />
      <div className="landing-page">
        <div className="light-row">
          <div className="column">
            <div className="title-semibold primary">
              What is a Venture Capital Trust (VCT)?
            </div>
            {/* <div className="divider align-left" /> */}
            <div className="content primary">
              The Venture Capital Trust (VCT) is a scheme where investment
              companies called VCTs focus on smaller businesses.
            </div>
          </div>
          <img
            src={WealthManagementImage2}
            className="landing-page-image"
            alt="Landing Page 2"
          />
        </div>
      </div>
      <div className="primary-container">
        <div className="column align-center">
          <div className="title-semibold">
            Managing Your Affairs And Lasting Power Of Attorney
          </div>

          <div className="content">
            You can formally appoint a friend, relative or professional to hold
            a lasting power of attorney that will allow them to act on your
            behalf. Lasting power of attorney (LPA) in England and Wales has no
            legal standing until it is registered with the Office of the Public
            Guardian. A lasting power of attorney is a legal document that lets
            you appoint someone you trust as an 'attorney' to make decisions on
            your behalf.
          </div>
          <div className="content">
            It can be drawn up at any time while you have capacity but has no
            legal standing until it is registered with the Office of the Public
            Guardian.
          </div>
          <div className="content-semibold">
            A registered LPA can, unless the document states differently, be
            used at any time, whether you have the mental ability to act for
            yourself or not.
          </div>
        </div>
      </div>
      <div className="landing-page">
        <div className="light-row reverse">
          <div className="column ">
            <div className="title-semibold primary">
              What is the Enterprise Investment Scheme?
            </div>
            {/* <div className="divider align-left" /> */}
            <div className="content primary">
              The Enterprise Investment Scheme (EIS) is a UK Government
              investment programme designed to help small companies that are
              considered risky to attract investors. Investors that buy shares
              in these risky - but often innovative - companies will receive tax
              relief, making an investment more lucrative.
            </div>
            <div className="content primary">
              Investors can reduce their tax liability by up to £300,000 for
              investing under the EIS scheme. Moreover, if the investor decides
              to sell the shares in the future, any profits made on these shares
              will not be subject to Capital Gains Tax (CGT). The shares must be
              owned for at least three years and can be purchased through the
              EIS fund or via the business directly.
            </div>
          </div>
          <img
            src={WealthManagementImage3}
            className="landing-page-image"
            alt="Landing Page 2"
          />
        </div>
        {/* <div className="divider align-center" /> */}
        <div className="light-row">
          <img
            src={WealthManagementImage4}
            className="landing-page-image"
            alt="Landing Page 2"
          />
          <div className="column">
            <div className="title-semibold primary">
              What is a single-asset fund investment?
            </div>
            {/* <div className="divider align-left" /> */}
            <div className="content primary">
              Single-asset fund investment is when an investment manager focuses
              on one security, asset, acquisition, or transaction. Please note,
              investment managers are not providing financial advice. They are
              operated by a single investor or a group of investors working for
              the same company or affiliation.
            </div>
            <div className="content primary">
              Single asset fund investment offers potential for lucrative
              investment growth, but it does expose you to some risks due to a
              lack of diversification. This can be offset by other investments.
              Management fees are low due to the single-asset investment.
            </div>
          </div>
        </div>
        {/* <div className="divider align-center" /> */}
        <div className="light-row">
          <div className="column ">
            <div className="title-semibold primary">
              What is inheritance tax?
            </div>
            {/* <div className="divider align-left" /> */}
            <div className="content primary">
              Inheritance tax is tax paid to HMRC on the value of the estate of
              a deceased person, as per the deceased’s will or common law.
              Spouses and civil partners do not pay inheritance tax when
              receiving an inheritance from their husband/wife/partner, and you
              may not have to pay anything if you inherit within the “nil-rate
              band”.
            </div>
          </div>
          <img
            src={WealthManagementImage5}
            className="landing-page-image"
            alt="Landing Page 2"
          />
        </div>
      </div>
      <div className="footer-legal">
        <div className="footer-legal-text">
          <div className="column align-center">
            <div className=" content-semibold primary">
              THE VALUE OF INVESTMENTS AND THE INCOME THEY PRODUCE CAN FALL AS
              WELL AS RISE.
            </div>
            <div className=" content-semibold primary">
              ESTATE AND INHERITANCE PLANNING IS NOT REGULATED BY THE FINANCIAL
              CONDUCT AUTHORITY.
            </div>
            <div className=" content-semibold primary" style={{textTransform:"uppercase"}}>
              VCTs invest in smaller, higher-risk companies and can be harder to
              sell. Tax reliefs may apply but depend on your circumstances and
              can change.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WealthManagement;
